import React from 'react';
import { Shield, Skull, Ban, Zap } from 'lucide-react';

export default function LiveAttacksTab({ honeypotVictims, permanentBans, dashboardData }) {
  return (
    <div className="space-y-6" data-testid="security-live-tab">
      <div className="grid grid-cols-4 gap-4">
        <div className="bg-red-500/10 rounded-2xl p-5 border border-red-500/30 text-center">
          <Zap className="w-8 h-8 text-red-400 mx-auto mb-2" />
          <p className="text-3xl font-bold text-red-400">{honeypotVictims.length}</p>
          <p className="text-xs text-muted-foreground">Attacks Blocked</p>
        </div>
        <div className="bg-yellow-500/10 rounded-2xl p-5 border border-yellow-500/30 text-center">
          <Ban className="w-8 h-8 text-yellow-400 mx-auto mb-2" />
          <p className="text-3xl font-bold text-yellow-400">{permanentBans.length}</p>
          <p className="text-xs text-muted-foreground">IPs Banned</p>
        </div>
        <div className="bg-purple-500/10 rounded-2xl p-5 border border-purple-500/30 text-center">
          <Skull className="w-8 h-8 text-purple-400 mx-auto mb-2" />
          <p className="text-3xl font-bold text-purple-400">{dashboardData?.most_targeted_paths?.length || 0}</p>
          <p className="text-xs text-muted-foreground">Targeted Paths</p>
        </div>
        <div className="bg-green-500/10 rounded-2xl p-5 border border-green-500/30 text-center">
          <Shield className="w-8 h-8 text-green-400 mx-auto mb-2" />
          <p className="text-3xl font-bold text-green-400">100%</p>
          <p className="text-xs text-muted-foreground">Protected</p>
        </div>
      </div>

      <div className="bg-card/60 rounded-2xl p-6 border border-purple-500/30">
        <h3 className="font-bold text-base mb-4 flex items-center gap-2">
          <Skull className="w-5 h-5 text-purple-400" /> Most Targeted Paths
        </h3>
        <div className="space-y-2">
          {!dashboardData?.most_targeted_paths?.length ? (
            <p className="text-center py-4 text-muted-foreground">No attacks recorded yet</p>
          ) : dashboardData.most_targeted_paths.map((item, i) => (
            <div key={i} className="flex items-center justify-between p-3 bg-secondary/50 rounded-lg">
              <div className="flex items-center gap-3">
                <span className="text-2xl font-bold text-purple-400">#{i + 1}</span>
                <code className="font-mono text-yellow-400">{item.path}</code>
              </div>
              <span className="text-red-400 font-bold">{item.count} attempts</span>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-card/60 rounded-2xl p-6 border border-red-500/30">
        <h3 className="font-bold text-base mb-4 flex items-center gap-2">
          <Zap className="w-5 h-5 text-red-400 animate-pulse" /> Live Attack Feed
          <span className="text-xs text-muted-foreground ml-2">(Last 20)</span>
        </h3>
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {honeypotVictims.length === 0 ? (
            <p className="text-center py-8 text-muted-foreground">No attacks detected. Honeypots are ready.</p>
          ) : honeypotVictims.slice(0, 20).map((v, i) => (
            <div key={i} className="p-4 bg-gradient-to-r from-red-500/10 to-transparent rounded-xl border-l-4 border-red-500">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center">
                    <Skull className="w-5 h-5 text-red-400" />
                  </div>
                  <div>
                    <span className="font-mono font-bold text-red-400">{v.ip}</span>
                    <p className="text-sm text-muted-foreground">tried <code className="text-yellow-400">{v.path}</code></p>
                  </div>
                </div>
                <div className="text-right">
                  <span className="px-2 py-1 bg-red-500/20 text-red-400 text-xs rounded-full">BLOCKED</span>
                  <p className="text-xs text-muted-foreground mt-1">{new Date(v.caught_at).toLocaleString()}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
